import './Container.css';
import React from 'react';

interface Props {
    children: React.ReactNode | React.ReactNode[],
}

const Container = ({children}: Props) => {
    return (
        <div className="container-outer">
            <div className="container-inner">
                {children}
            </div>
        </div>
    )
}

export default Container;